module.exports = __webpack_public_path__ + "img/gov-up.db86c701.svg";